import ApiIntegrationGithub from "../../../../../core/gd/api/integrations/github";

export default async function githubIntegration_Disable (){
    try{
        await ApiIntegrationGithub.disableIntegration();

        gd.modal.hide();
        gd.modules.github._isEnabled = false

        // gd.goTo('o/'+gd.companyId+'/settings/integrations');
        gd.getApp().start();
    }
    catch (e: any){
        console.log(e)
        gd.modal.hide();
    }
}